<template>
  <el-container v-loading="isShowLoading">
    <el-main>
      <el-row>
        <el-form :model="filterData" :inline="true">
          <el-form-item>
            <el-input v-model="filterData.dsrwMc" placeholder="请输入任务名称"></el-input>
          </el-form-item>
          <el-form-item>
            <el-input v-model="filterData.ssyy" placeholder="请输入所属应用"></el-input>
          </el-form-item>
          <el-form-item>
            <el-select v-model="filterData.zxzt" placeholder="--执行状态选择--">
              <el-option label="--执行状态选择--" value></el-option>
              <el-option label="成功" value="Y"></el-option>
              <el-option label="失败" value="N"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" icon="el-icon-search" @click="onFilter">查询</el-button>
          </el-form-item>
        </el-form>
      </el-row>
      <el-row>
        <el-col :span="24">
        </el-col>
      </el-row>

      <el-table ref="singleTable" :data="recordData" highlight-current-row style="width: 100%" :height="tableHeight"
        :header-cell-style="{background:'#f5f7fa', color: 'black'}" border :stripe="stripeVisible">
        <el-table-column type="index" width="50" label="序号"></el-table-column>
        <el-table-column property="dsrwMc" label="定时任务名称" width="300"></el-table-column>
        <el-table-column property="ssyy" label="所属应用" width="120"></el-table-column>
        <el-table-column property="zxkssj" label="执行开始时间" width="155"></el-table-column>
        <el-table-column property="zxjssj" label="执行结束时间" width="155"></el-table-column>
        <el-table-column property="zxzt" label="执行状态" width="80">
          <template slot-scope="scope">
            <div v-if="scope.row.zxzt == 'Y'">
              <i class="el-icon-success"></i>成功
            </div>
            <div v-else-if="scope.row.zxzt == 'N'">
              <i class="el-icon-remove"></i>失败
            </div>
          </template>
        </el-table-column>
        <el-table-column property="zxjg" label="执行结果">
            <template slot-scope="scope">
              <div
                class="dt"
                @click="columnDeal(scope.row.zxjg)"
              >
                {{scope.row.zxjg}}
              </div>
            </template>
        </el-table-column>
      </el-table>
      <el-row style="margin: 18px 8px">
        <el-col :span="24">
          <pagination
            v-show="pagination.total/pagination.pageSize>1"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.total"
            :page.sync="pagination.page"
            :limit.sync="pagination.pageSize"
            @pagination="onFilter"
          />
        </el-col>
      </el-row>

      <div style="height: 60px"></div>
    </el-main>
  </el-container>
</template>

<script>
let _kits, _table;
export default {
  data() {
    return {
      isShowLoading: true,
      isShowItem: false,
      pageWidth: 600,
      //页面布局相关
      layout: {
        loading: true,
        width: 600,
        wd: "80%",
        edit: false
      },
      //数据绑定相关
      filterData: {}, //过滤信息
      recordData: [], //展示信息
      pagination: {
        total: 0,
        page: 1,
        pageSize: 10
      }
    };
  },
  methods: {
    onFilter() {
      console.log(_kits.data("filterData"));
      this.layout.loading = true;
      _table.load();
    },
    init() {
      _table.load();
    }
  },
  created() {
    this.pageWidth = window.innerWidth - 200;
    _kits = this.$kits();
    _table = _kits.table(
      "QUERYZXJL",
      () => {
        return Object.assign({}, this.filterData, this.pagination);
      },
      result => {
        this.isShowLoading = false;
        this.recordData = result.list;
        this.pagination.total = Number.parseInt(result.total);
      }
    );
    this.init();
  },
  mounted() {
    this.isShowLoading = false;
  }
};
</script>
<style scoped>
</style>
